import { rotateBitmapAtRightAngles } from "@brickme/project-core/src/bitmap/rotate.ts";
import { ensureExhaustive } from "../utils/never.ts";
import bitmapToSmallestSizeEncodedImage from "../bitmap/bitmap-to-smallest-size-encoded-image.ts";
import type { SourceImage, SourceRotation } from "./source-image.ts";

async function rotateSourceImage(
	sourceImage: SourceImage,
	rotation: SourceRotation,
): Promise<SourceImage> {
	switch (rotation) {
		case 0:
			return sourceImage;
		case 90:
		case 180:
		case 270:
			{
				const { bitmap, fileName } = sourceImage;
				const rotatedBitmap = rotateBitmapAtRightAngles(bitmap, rotation);
				const encoded = await bitmapToSmallestSizeEncodedImage(
					rotatedBitmap,
					undefined,
				);
				return {
					bitmap: rotatedBitmap,
					fileName,
					contentType: encoded.mimeType,
					content: encoded.buffer as ArrayBuffer,
				};
			}
			break;
		default:
			ensureExhaustive(rotation);
	}
}

export default rotateSourceImage;
